import React from 'react';
import { useGameStore } from '../../state/gameStore';
import { appBus } from '../../../app/app-events';

const GameOverModal: React.FC = () => {
  const { activeModal } = useGameStore(state => state.ui);
  const { stats } = useGameStore(state => state.game);
  const hideModal = useGameStore(state => state.hideModal);

  if (activeModal !== 'gameOver') return null;

  const handleRestart = () => {
      hideModal();
      appBus.emit('reset-game', {});
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/80 z-50 backdrop-blur-sm pointer-events-auto animate-in fade-in duration-300">
      <div className="bg-slate-900 border border-emerald-500/50 rounded-2xl p-8 max-w-md w-full shadow-2xl transform transition-all scale-100">
        <div className="text-center mb-6">
          <div className="inline-block p-3 rounded-full bg-emerald-500/10 mb-4">
             <span className="text-4xl">🎯</span>
          </div>
          <h2 className="text-3xl font-bold text-white mb-2">Game Over!</h2>
          <div className="text-emerald-400 font-medium tracking-wider text-sm bg-emerald-500/10 inline-block px-3 py-1 rounded-full">
             All cuts used
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-8">
           <div className="bg-slate-800 p-4 rounded-xl text-center border border-white/5">
              <div className="text-slate-400 text-xs tracking-wider mb-1">Final Score</div>
              <div className="text-3xl font-bold text-amber-400">{stats.currentScore}</div>
           </div>
           <div className="bg-slate-800 p-4 rounded-xl text-center border border-white/5">
              <div className="text-slate-400 text-xs tracking-wider mb-1">Reduction</div>
              <div className="text-3xl font-bold text-emerald-400">{stats.volumeReduction.toFixed(1)}%</div>
           </div>
        </div>

        <div className="text-slate-300 text-center mb-8 text-sm">
            Congratulations! You have exhausted your cuts limit. 
            Try again to achieve a better score or volume reduction.
        </div>

        <div className="flex gap-4">
           <button
             onClick={handleRestart}
             className="flex-1 bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 px-4 rounded-xl transition-all transform hover:scale-[1.02] shadow-lg shadow-emerald-500/20"
           >
             🔄 Restart
           </button>
           <button
             onClick={() => hideModal()}
             className="px-6 py-3 bg-slate-800 hover:bg-slate-700 text-white font-bold rounded-xl transition-colors"
           >
             Close
           </button>
        </div>
      </div>
    </div>
  );
};

export default GameOverModal;
